<script>
export default {
  name: 'events-program',
  computed: {
    modal() {
      return this.$store.getters['events/getProgramModal']
    },
    program() {
      return this.$store.getters['events/getField']('editForm.program')
    }
  }
}
</script>
<template>
  <div class="card">
    <div class="events-program">
      <b-loading
        v-if="modal.isLoading"
        :is-full-page="false"
        :active="modal.isLoading"
      />
      <div
        v-else
      >
        <h2 class="events-program__header">
          {{ modal.header }}
        </h2>
        <div
          class="events-program__content"
          v-html="program"
        />
      </div>
    </div>
  </div>
</template>